import { useEffect, useState } from 'react';
export function useDynamicLink(spId) 
{
  const [spData, setData] = useState([]);
  useEffect(() => 
  {
    const getDynamicLink = async () => {
      try 
      {
        const response = await fetch(global.config.API_URL + "menu/MenuById/" + spId);
        const result = await response.json();
        setData(result);
        if( global.config.IsPrint === true ) { console.info('getDynamicLink : Result',result); }
      }
      catch (error) 
      {
        console.error('DynamicLink: Error', error.message);
      }
    };
    getDynamicLink();
  }, [spId]);
  return spData;
}

export function useDepartmentList() 
{
  const [Departments, setDepartment] = useState([]);
  useEffect(() => {
    const getDepartmentList = async () => {
      try 
      {
        const response = await fetch(global.config.API_URL + "departments/allDepartments");
        const result = await response.json();
        setDepartment(result);
        if( global.config.IsPrint === true ) { console.info('getDepartmentList : Result',result); }
      }
      catch (error) 
      {
        console.error('DepartmentList: Error', error.message);
      }
    };
    getDepartmentList();
  }, []);
  return Departments;
}

export function useAcdemicDepartmentList() 
{
  const [Departments, setDepartment] = useState([]);
  useEffect(() => {
    const getDepartmentList = async () => {
      try 
      {
        const response = await fetch(global.config.API_URL + "departments/academicDepartments");
        const result = await response.json();
        setDepartment(result);
        if( global.config.IsPrint === true ) { console.info('getDepartmentList : Result',result); }
      }
      catch (error) 
      {
        console.error('DepartmentList: Error', error.message);
      }
    };
    getDepartmentList();
  }, []);
  return Departments;
}